import React from 'react';

import View from '../../components/Templates/View';

const ViewPage = props => {
  return <View {...props} />;
};

export default ViewPage;
